import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Transition } from '@headlessui/react';
import useVisibility from '../../../../../_Apps/shared/utils/hooks/useVisibility';

import { fetchNextProperties, setPage } from '../../../../reducers/propertiesSlice';

import EstimationCard from '../../components/EstimationCard';
import PropertyHuntCard from '../../components/PropertyHuntCard';
import PropertyCard from '../../components/PropertyCard';
import Loader from './components/Loader';
import BuyerAlertLink from './components/BuyerAlertLink';

const PropertiesList = () => {
  const { display: displayMap } = useSelector((state) => state.mapSettings);
  const { requestPropertiesState, collection: propertiesCollection, requestFetchState, collectionTotal: propertiesCollectionLength } = useSelector((state) => state.properties);
  const { baseCollection: filtersCollection, selectedTab, sortFilter } = useSelector((state) => state.filters);
  const { desktopDevice } = useSelector((state) => state.viewportSlice);
  const properties = useSelector((state) => state.properties);
  const dispatch = useDispatch();
  const propertiesRef = useRef(properties);

  const [observerIsVisible, fetchObserverRef] = useVisibility({
    root: null,
    rootMargin: '0px',
    threshold: 0,
  });

  useEffect(() => {
    propertiesRef.current = properties;
  }, [properties])

  useEffect(() => {
    if (!observerIsVisible) return;

    if (propertiesCollectionLength > propertiesRef?.current.collection.length && selectedTab !== 'mobileFilters') {
      const filters = Object.assign({}, filtersCollection, sortFilter ? { sortFilter } : {})
      dispatch(fetchNextProperties({ filters, page: propertiesRef.current.page + 1 }))
      dispatch(setPage(propertiesRef.current.page + 1))
    }
  }, [observerIsVisible, propertiesCollection.length])

  useEffect(() => {
    if (desktopDevice || selectedTab === 'mobileFilters') return

    window.scrollTo({ top: 0, behavior: 'smooth' })
  }, [selectedTab]);

  const displayPropertyList = () => {
    const propertiesAndEstimationCards = [];
    let cardInsertCount = 0;

    propertiesCollection.forEach((property, index) => {
      const propertyElement = (
        <Transition
          key={`property-${property.id}`}
          enter='fade-enter'
          enterFrom='fade-enter-from'
          enterTo='fade-enter-to'
          leave='fade-leave'
          leaveFrom='fade-leave-from'
          leaveTo='fade-leave-to'
          show
          appear
        >
          <PropertyCard property={property} />
        </Transition>
      );

      propertiesAndEstimationCards.push(propertyElement);

      // Insert Buyer Alert Card or Property Hunt Card alternately every 8 property cards
      if ((index + 2) % 8 === 0) {
        const isEstimationCard = cardInsertCount % 2 === 0;
        propertiesAndEstimationCards.push(
          isEstimationCard 
            ? <EstimationCard key={`buyer-alert-${index}`} />
            : <PropertyHuntCard key={`property-hunt-${index}`} />
        );
        cardInsertCount++;
      }
    });

    return propertiesAndEstimationCards;
  };

  return (
    <>
      <div>
        {((!desktopDevice && !displayMap && selectedTab !== 'mobileFilters') || desktopDevice) && (
          <div className='vesta-cards-container vesta-flex-wrap vesta-flex-row-center vesta-gap-25'>
            {displayPropertyList()}
            <BuyerAlertLink />
          </div>
        )}
      </div>

      {requestPropertiesState === 'done' && <div style={{ height: '1px' }} ref={fetchObserverRef} />}

      <Loader isLoading={requestFetchState === 'pending' && !displayMap} />
    </>
  )
};

export default PropertiesList;
